import React from 'react';
import { SeasonalActivity } from './SeasonalActivity';
import { IconHeader } from './Dialog';
import { Date } from '../Icons/CustomIcons';
import DateRangeListEditor from '../Forms/DateRangeListEditor';

// Seasonal toggle + a list of validity/accessibility date ranges ({ from, until }).
// Replaces the single from/until pair so e.g. school holidays can be entered.
export const DateRangesSection = ({
  isSeasonal,
  onIsSeasonalChange,
  ranges,
  onRangesChange,
  labelFrom = 'Gültig ab',
  labelUntil = 'Gültig bis',
  fromRequired = false,
}) => {
  return (
    <div className="validity-section">
      <IconHeader Icon={<Date size={20} color="#fff" />}>
        Daten
      </IconHeader>

      <SeasonalActivity
        checked={isSeasonal}
        onCheckedChange={onIsSeasonalChange}
        showFieldInfo
        fieldInfoText={"Wenn angeklickt, gelten die Öffnungszeiten nur für eine Saison. Jährliches Update erforderlich."}
      />

      <DateRangeListEditor
        ranges={ranges}
        onChange={onRangesChange}
        labelFrom={labelFrom}
        labelUntil={labelUntil}
        fromRequired={fromRequired}
      />
    </div>
  );
};
